import React from 'react';
import withRouter from '../../lib/router/withRouter';

import PageTemplate from '../../components/template/PageTemplate';
import ProductVersionWrap from '../../views/product/version/ProductVersionWrap';
import useToastMsg from '../../hooks/common/useToastMsg';
import useProductVersion from '../../hooks/queries/product/useProductVersion';
import { PRODUCT_VERSION_MODEL } from '../../store/modules/product/models';
import productToastMsg from '../../constants/service/toastMsg/productToastMsg';
import { PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';
import { extractErrorMessage } from '../../lib/utils/checkErrorResponse';

const ProductVersion = ({ match }) => {
  const toastMsg = useToastMsg();
  const { data, getProductVersionDetailMutate } = useProductVersion(match.params.id, {
    initialData: PRODUCT_VERSION_MODEL,
    onSuccess: () => {
      toastMsg.success(productToastMsg.GET_PRODUCT_VERSION_INFO_REQUEST_SUCCESS);
    },
    onError: (error) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });

  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_DETAIL}>
      <ProductVersionWrap data={data} getProductVersionDetailMutate={getProductVersionDetailMutate} />
    </PageTemplate>
  );
};

export default withRouter(ProductVersion);
